import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { customer } from "../characters/Customer";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doTransition } from "../helpers/helpers";
import { images } from "./images";
import { V6VanessaCustomerMeetingAfter } from "./V6";


export const V6VanessaCustomerMeeting = async (): Promise<any> => {
    doTransition(images.v6.VanessaCustomerMeeting_0);
    vanessa.talk(`The pervert is inside!\nYou see him, right?`);
    mc.talk(`Yeah, he is waiting.`);
    if (Game.seenScenarios.includes(`V6Underpass`)) {
        mc.talk(`He texted me so late, he must've been so eager to meet you.`);
    } else {

        vanessa.talk(`How did he get here so fast?`);
        mc.talk(`He must've been eager to meet you.`);
    }
    vanessa.talk(`His dream is about to come true. Let's see what he wants.`);

    ImageClass.setImage(images.v6.VanessaCustomerMeeting_1, { transition: true });
    vanessa.talk(`Ok so this is the plan:`);
    if (Game.seenScenarios.includes(`V5ChrisRandomGirl`)) {
        if (Game.seenScenarios.includes(`V5ChrisRandomGirl_ReturnToMerry`)) {
            mc.think(`Fuck is that Merry?`);
            mc.think(`I hope she doesn't notice me... I don't have time for her right now.`);
        } else {
            mc.think(`Chris is with that girl... I think Merry is her name.`);
            mc.think(`How can he even talk to her? She is batshit crazy.`);
        }

    } else {
        mc.think(`Who is Chris sitting with? I've never seen her before.`);

    }

    vanessa.talk(`Hey! Focus! Stop staring at Chris and listen to me.`);
    mc.talk(`Oh, sure. Yeah, what were you saying?`);
    vanessa.talk(`I said that you should let me handle it.`);
    mc.talk(`Really? What am I supposed to do then?`);
    vanessa.talk(`Nothing. Sit there and look intimidating.`);
    mc.talk(`Ok... Anything else?`);
    vanessa.talk(`No.\nLet's go.`);



    return jump(V6VanessaCustomerMeeting_2, "V6VanessaCustomerMeeting_2");
};

export const V6VanessaCustomerMeeting_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_2, { transition: true });
    vanessa.talk(`What?`);
    customer.talk(`That's not how you address someone who wants to help you.`);
    customer.talk(`Didn't your parents teach you some manners?`);
    vanessa.talk(`If I had any I wouldn't have been in this situation in the first place.`);
    customer.talk(`True.`);
    vanessa.talk(`Grandpa, are you gonna tell me what do you want or what?`);
    customer.talk(`You need to relax.`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_3);
    customer.talk(`Didn't your friend tell you I come in peace?`);
    vanessa.talk(`Not really.`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_4);
    customer.talk(`Why don't you sit down so we can have a proper discussion?`);
    vanessa.talk(`I'm fine standing.`);
    customer.talk(`I insist.`);
    customer.talk(`You want your job back, right?`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_5);
    vanessa.talk(`I'm sitting.\nHappy?`);
    customer.talk(`Yes, because we are making progress.`);
    vanessa.talk(`Just tell me what do you want.`);
    customer.talk(`To get to know you better, of course.`);
    customer.talk(`Tell me, what does a young lady like yourself do in life?`);
    vanessa.talk(`I'm unemployed.`);

    customer.talk(`Besides that?`);
    vanessa.talk(`Trying to get my job back.`);

    customer.talk(`You know, you seem a bit tense.`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_7);

    customer.talk(`Why don't you relax?`);
    customer.talk(`It's on me, don't worry.`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_8);
    vanessa.talk(`I'm not gonna drink your grandpa's roofie special drink.`);
    customer.talk(`Are you going to refuse a free drink?`);
    vanessa.talk(`I don't want any favors from you.`);
    customer.talk(`Getting your job back is a favor. Isn't it?`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_7);
    vanessa.talk(`...`);
    customer.talk(`Just drink with me, your friend is here to make sure nothing happens.`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_9);
    vanessa.talk(`Ok, fuck it.`);
    customer.talk(`Cheers.`);






    return jump(V6VanessaCustomerMeeting_3, "V6VanessaCustomerMeeting_3");
};

export const V6VanessaCustomerMeeting_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_10);

    mc.think(`It was so obvious she ain't gonna refuse free booze.`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_11);
    customer.talk(`Isn't that nice? The two of us getting along.`);
    vanessa.talk(`...`);
    customer.talk(`Ok, so let me get to the point.`);
    customer.talk(`The other day, I just came to get a cup of coffee at my friend's place.`);
    customer.talk(`And by friend I mean the owner.`);
    customer.talk(`In my wildest dreams I wouldn't have imagined to be treated like that.`);

    if (mc.properties.v3RudeToTheCustomer) {
        vanessa.talk(`That wasn't my fault.`);
        customer.talk(`Don't act stupid. I waited a few minutes and saw you two are friends.`);
        customer.talk(`So yes. You are to blame.`);
    } else {

    }
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {
        vanessa.talk(`Haha, it was kinda funny.`);
        customer.talk(`Excuse me?`);
        vanessa.talk(`Haha, nothing.`);
        vanessa.talk(`Please continue.`);
        customer.talk(`Anyway.`);
    }

    customer.talk(`I had a small chat with the owner.\nThe funny thing he had already planned to fire you, I just pressed the right button.`);
    customer.talk(`And you know what else?`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {

        vanessa.talk(`Hehe, what?`);
        mc.think(`What's wrong with her?`);
        mc.think(`Oh fuck! She took the pill at her place!`);
        if (Game.seenScenarios.includes(`AfterClubSexTapeAgree4JoePassedout`)) {
            mc.think(`Good thing that I came with her.`);
            mc.think(`I hope she won't pass out like Joey did.`);
        } else {

            mc.think(`I don't think that it's smart mixing that with alcohol...`);
        }

    } else {

        vanessa.talk(`What?`);
    }

    customer.talk(`He thinks that someone is stealing from his register.`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {

        vanessa.talk(`Hehe, who would do that? That's so stupid!`);
    } else {
        vanessa.talk(`Don't look at me like that. I have nothing to do with that.`);
        customer.talk(`I didn't say it was you, of course. We are just talking here.`);
    }
    mc.think(`Vanessa is a lot of things. But I don't think she'd do that.`);

    customer.talk(`There is something I'm really interested in.`);
    customer.talk(`But before I'm gonna ask, why don't you come a little closer?`);

    return jump(V6VanessaCustomerMeeting_3_Question, "V6VanessaCustomerMeeting_3_Question");
};

export const V6VanessaCustomerMeeting_3_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_11);
    await customer.setQuestion(new Question({ text: `I'm not a young man anymore and it's hard to hear you from that far.`, options: { think: false }, key: `v6CustomerVanessaIntervened` })
        .option({ title: `Don't intervene`, key: false })
        .option({ title: `Intervene`, key: true }));


    if (Question.globalAnswers.v6CustomerVanessaIntervened) {
        return jump(V6VanessaCustomerMeeting_3_Question_Intervene, "V6VanessaCustomerMeeting_3_Question_Intervene");

    } else {
        return jump(V6VanessaCustomerMeeting_3_Question_DontIntervene, "V6VanessaCustomerMeeting_3_Question_DontIntervene");

    }
};



export const V6VanessaCustomerMeeting_3_Question_DontIntervene = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_11);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {
        vanessa.talk(`Sure thing grandpa!`);
        vanessa.talk(`How close do you want me to sit?`);
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_13, { transition: true });
        vanessa.talk(`Is this close enough?`);
        customer.talk(`That's perfect.`);

        vanessa.talk(`You know you aren't that bad up close.`);
        customer.talk(`By the way, you can stop calling me grandpa.`);
        vanessa.talk(`Sure thing grandpa stud!`);
        vanessa.talk(`The hairs in your ear are really hot!`);
        mc.think(`I don't like where this is going...`);

        customer.talk(`You see, you can be a real treat if you want to.`);
        empty.think(`*Phone Rings*`);
        customer.talk(`Excuse me, that's mine.`);
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_14);
        customer.talk(`Mmm... I'll get back to her later...`, { method: "Mumbling" });
        vanessa.talk(`Who's that?`);
        customer.talk(`No one.`);
        vanessa.talk(`Answer it!`);
        customer.talk(`I'll get back to her later.`);
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_15);
        vanessa.talk(`There you go! I helped!`);
        customer.talk(`What the...`);
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_16);
        customer.talk(`Hey sweetie!`);
        customer.talk(`No no...`);
        customer.talk(`Yes.`);
        customer.talk(`Just a walk.`);
        customer.talk(`I have.`);
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_17);
        customer.talk(`Milk... Sugar... What else?`);
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_18);
        customer.talk(`Sweetie, I'm gonna call you back.`);
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_19, { transition: true });
        customer.talk(`I need to go.`);
        customer.talk(`The bill is taken care of.\nBye!`);
        vanessa.talk(`What about my job?`);
        customer.talk(`We'll talk about that another time.`);
        return jump(V6VanessaCustomerMeeting_5, "V6VanessaCustomerMeeting_5");
    } else {
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_12);
        vanessa.talk(`No way grandpa! I'm staying right here. Buy a hearing device if you have problems with your ears.`);

    }

    return jump(V6VanessaCustomerMeeting_4, "V6VanessaCustomerMeeting_4");
};



export const V6VanessaCustomerMeeting_3_Question_Intervene = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_11);
    mc.talk(`Chill dude, she is fine where she is.`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {
        vanessa.talk(`Hehe, now you must be regretting inviting him... I would have come very very close to you!`);

    } else {

        ImageClass.setImage(images.v6.VanessaCustomerMeeting_12);
        vanessa.talk(`He is right! I'm not getting any closer to you.`);
    }

    return jump(V6VanessaCustomerMeeting_4, "V6VanessaCustomerMeeting_4");
};

export const V6VanessaCustomerMeeting_4 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_12);

    customer.talk(`Right there is fine. But don't come running and say I didn't hear you correctly.`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_20);
    vanessa.talk(`I won't, don't worry.`);

    customer.talk(`So let me ask you a question.`);
    customer.talk(`Why not get a different job? Let's take this place for example.`);
    customer.talk(`Wouldn't you want to work here?`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {
        vanessa.talk(`Here? No way! I'll drink the whole bar hehe!`);
        customer.talk(`I can imagine that...`);
    } else {

        vanessa.talk(`No.`);
    }

    customer.talk(`Another coffee shop maybe?`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {
        vanessa.talk(`Other ones are too far!!! I hate walking! Especially on heels.`);
        vanessa.talk(`Do you know how hard it is?`);
        vanessa.talk(`I bet you have! You seem like the type! Hehe.`);
        customer.talk(`Stop.`);
        customer.talk(`I just want to understand what's so special about that one?`);
        vanessa.talk(`The heels?`);
        customer.talk(`The coffee shop...`);
        vanessa.talk(`I really really like that place!`);
    } else {
        vanessa.talk(`No. I want my old job and that's final.`);
        customer.talk(`But please, help me understand. What's so special about that one?`);
        vanessa.talk(`The lack of customers, ok? Can I have it back now?`);
    }

    empty.think(`*Phone Rings*`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_21);
    customer.talk(`Shit.`);
    ImageClass.setImage(images.v6.VanessaCustomerMeeting_22);
    customer.talk(`I need to get going.`);
    vanessa.talk(`Wait, what about my job? Did I get it back? I did everything you asked.`);

    customer.talk(`We'll talk about that another time.`);
    customer.talk(`Bye!`);

    return jump(V6VanessaCustomerMeeting_5, "V6VanessaCustomerMeeting_5");
};


export const V6VanessaCustomerMeeting_5 = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_24, { duration: 1 });
        mc.talk(`Are you ok?`);
        vanessa.talk(`Why wouldn't I be?`);
        mc.talk(`You look...`);
        vanessa.talk(`HOT?`);
        mc.talk(`That too.`);
    } else {
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_23, { duration: 1 });
        vanessa.talk(`What the fuck?! He just left.`);
        mc.talk(`Did you really expect a different result?`);
        vanessa.talk(`Kinda... I dunno.`);
    }
    empty.think(`*Buzz Buzz*`);
    mc.think(`That's not mine...`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {

        ImageClass.setImage(images.v6.VanessaCustomerMeeting_25);
    } else {

        ImageClass.setImage(images.v6.VanessaCustomerMeeting_26);
    }
    vanessa.talk(`Oh!`);
    mc.talk(`Who's that?`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {
        vanessa.talk(`My sweet Joe is coming to pick me up!`);
        ImageClass.setImage(images.v6.VanessaCustomerMeeting_24);
        if (mc.properties.joeStatus === "enemy") {
            vanessa.talk(`You should leave so he won't kick your ass haha.`);
            mc.talk(`...`);
            vanessa.talk(`Kidding!`);
        } else {

        }

        vanessa.talk(`I'm gonna wait for him outside.\nBYE!`);
    } else {
        if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival`)) {

            vanessa.talk(`That's Joe.`);
            ImageClass.setImage(images.v6.VanessaCustomerMeeting_23);
            if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival_Question_Watch`)) {
                vanessa.talk(`I told him I was going to walk Ann home. He asked what is taking me so long so I'll better get going.`);
                mc.talk(`Wait. What about Ann by the way? How did you pull that off?`);
                vanessa.talk(`Haha, she still thinks that was you. I'll explain everything tomorrow.\nI gotta go.`);
                mc.talk(`Alright... Cya tomorrow.`);
            } else {
                vanessa.talk(`I told him I'm going to Ann's place to explain everything, since she wasn't answering her phone.`);
                mc.talk(`Which obviously you didn't...`);
                vanessa.talk(`She will forgive me, she always does.`);
                vanessa.talk(`Anyway, I need to get going before Joe will start suspecting I didn't go there.`);
                mc.talk(`Cya.`);
            }

        } else {

            vanessa.talk(`Joe is coming to pick me up.`);
            ImageClass.setImage(images.v6.VanessaCustomerMeeting_23);
            if (mc.properties.joeStatus === "enemy") {
                vanessa.talk(`I think it's for the best he won't see us together.`);
                mc.talk(`Yeah, I agree.`);
            } else {
                vanessa.talk(`Do you need a ride home?`);
                mc.talk(`Nah, that's ok, I'll just walk.`);
                vanessa.talk(`Sure.`);
            }

            vanessa.talk(`I'm gonna wait for him outside.`);
            vanessa.talk(`Cya ${mc.name}!`);
            mc.talk(`Bye Vanessa.`);
        }
    }

    mc.think(`Well... Time to go home.`);

    return jump(V6VanessaCustomerMeetingAfter, "V6VanessaCustomerMeetingAfter");
};
